module.exports = __webpack_public_path__ + "img/FibreLam.9efaa581.webp";